/**
 * Query keys for TanStack Query
 */
export const DEVICE_QUERY_KEYS = {
  all: ['devices'] as const,
  lists: () => [...DEVICE_QUERY_KEYS.all, 'list'] as const,
  list: (pbxId: number, params: Record<string, unknown>) =>
    [...DEVICE_QUERY_KEYS.lists(), pbxId, params] as const,
  details: () => [...DEVICE_QUERY_KEYS.all, 'detail'] as const,
  detail: (pbxId: number, deviceId: number) =>
    [...DEVICE_QUERY_KEYS.details(), pbxId, deviceId] as const,
  models: () => ['deviceModels'] as const,
  systemDefaults: (pbxId: number) => ['systemDefaults', pbxId] as const,
  extensionsLine: (pbxId: number) => ['extensionsLine', pbxId] as const,
  extensionsSharedVoicemailBox: (pbxId: number) =>
    ['extensionsSharedVoicemailBox', pbxId] as const,
  users: (pbxId: number) => ['users', pbxId] as const,
  directories: (pbxId: number) => ['directories', pbxId] as const,
} as const
